'use client';

import type { ReactNode } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';
import type { ThemeSpaces } from '@frameio/vapor-theme';
import { theme } from '@frameio/vapor-theme';

/**
 * @deprecated Avoid using this type as this module is deprecated.
 */
export type Alignments = keyof typeof alignments;

/**
 * @deprecated `StackProps` has been deprecated along with the `Stack` component.
 * Use a `<div>` with CSS modules or inline styles instead. For vertical spacing,
 * use flexbox with `flex-direction: column` and `gap`.
 */
export type StackProps = {
  children?: ReactNode;
  alignX?: Alignments;
  gap?: ThemeSpaces;
  as?: any;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated `Stack` has been deprecated. Use a `<div>` with CSS modules or
 * inline styles instead. For vertical spacing, use flexbox with
 * `flex-direction: column` and `gap`.
 */
export const Stack = React.forwardRef(
  (
    { alignX, gap = 0, children, ...other }: StackProps,
    ref: React.Ref<HTMLDivElement>
  ) => (
    <StyledStack ref={ref} {...other}>
      {React.Children.map(children, (child: any, i) => {
        return React.isValidElement(child) ? (
          <StackItem
            key={i}
            $alignX={alignX}
            $gap={gap}
            as={other.as === 'ul' ? 'li' : undefined}
            data-testid={
              // @ts-expect-error FIXME(noImplicitAny)
              other['data-testid']
                // @ts-expect-error FIXME(noImplicitAny)
                ? `${other['data-testid']}--item-${i}`
                : undefined
            }
          >
            {child}
          </StackItem>
        ) : (
          child
        );
      })}
    </StyledStack>
  )
);

type StackItemProps = {
  $gap: ThemeSpaces;
  $alignX?: Alignments;
};

export const StackItem = styled.div<StackItemProps>`
  &:not(:last-child) {
    padding-bottom: ${(p) => theme.spaces[p.$gap]};
  }

  ${(p) => {
    if (p.$alignX) {
      return css<StackItemProps>`
        align-items: ${alignments[p.$alignX]};
        display: flex;
        flex-direction: column;
      `;
    }
    return css``;
  }}
`;

const StyledStack = styled.div`
  border: 0;
  display: block;
  margin: 0;
  padding: 0;

  li {
    list-style-type: none;
  }
`;

const alignments = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  auto: 'auto',
};
